import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cause-social-network',
  templateUrl: './social-network.component.html',
  styles: []
})
export class SocialNetworkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
